import { t } from '../i18n';
/** Folder-tree helpers for the content library (Phase 16 Step 6). The API returns the whole tree. */
import type { ContentFolder } from '@codot/contracts';

/** Ancestors from the top down, ending with `id` itself ([] for the top level). */
export function folderPath(folders: readonly ContentFolder[], id: string | null): ContentFolder[] {
  const byId = new Map(folders.map((f) => [f.id, f]));
  const out: ContentFolder[] = [];
  for (let cur = id ? byId.get(id) : undefined; cur && out.length < 50; cur = cur.parentId ? byId.get(cur.parentId) : undefined)
    out.unshift(cur);
  return out;
}

export const childFolders = (folders: readonly ContentFolder[], parentId: string | null) =>
  folders.filter((f) => f.parentId === parentId).sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

/** `id` and every folder below it (a folder can't move into any of these). */
export function subtreeIds(folders: readonly ContentFolder[], id: string): Set<string> {
  const out = new Set([id]);
  let grew = true;
  while (grew) {
    grew = false;
    for (const f of folders) {
      if (f.parentId && out.has(f.parentId) && !out.has(f.id)) {
        out.add(f.id);
        grew = true;
      }
    }
  }
  return out;
}

/** "Content › Ramadan › Week 1" for search results outside the current folder. */
export const pathLabel = (folders: readonly ContentFolder[], id: string | null) =>
  [t('content.title'), ...folderPath(folders, id).map((f) => f.name)].join(' › ');

/** Drag-and-drop payload type for moving library items (distinct from OS file drops, which upload). */
export const DRAG_TYPE = 'application/x-codot-content';
export interface DragPayload {
  items: { kind: 'media' | 'campaign' | 'playlist'; id: string }[];
  folderIds: string[];
}
